module.exports = __webpack_public_path__ + "img/envelope.f8721ffa.svg";